'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var web = require('@react-spring/web');
var d = require('./d.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Spinner = styled.svg.withConfig({
  componentId: "nq3y5y-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    width: '1rem',
    height: 'auto',
    fill: '#000',
    verticalAlign: 'initial'
  }, s);
});
var AnimatedSpinner = web.animated(Spinner);
var BitIconSpinner = function BitIconSpinner(_ref2) {
  var s = _ref2.s,
    _ref2$keyframes = _ref2.keyframes;
  _ref2$keyframes = _ref2$keyframes === void 0 ? {} : _ref2$keyframes;
  var _ref2$keyframes$durat = _ref2$keyframes.duration,
    duration = _ref2$keyframes$durat === void 0 ? 1000 : _ref2$keyframes$durat,
    _ref2$keyframes$from = _ref2$keyframes.from,
    from = _ref2$keyframes$from === void 0 ? undefined : _ref2$keyframes$from,
    _ref2$keyframes$to = _ref2$keyframes.to,
    to = _ref2$keyframes$to === void 0 ? undefined : _ref2$keyframes$to,
    className = _ref2.className;
  var style = web.useSpring({
    config: {
      duration: duration,
      mass: 1,
      tension: 500,
      friction: 1,
      clamp: true
    },
    loop: true,
    from: from || {
      transform: 'rotate(0deg)'
    },
    to: to || {
      transform: 'rotate(360deg)'
    }
  });
  return /*#__PURE__*/React.createElement(AnimatedSpinner, {
    role: "status",
    style: style,
    s: s,
    className: className,
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: d.default
  }));
};
BitIconSpinner.defaultProps = {
  s: undefined,
  keyframes: undefined,
  className: undefined
};
BitIconSpinner.propTypes = {
  className: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    verticalAlign: PropTypes.string
  }),
  keyframes: PropTypes.shape({
    duration: PropTypes.number,
    from: PropTypes.shape({
      transform: PropTypes.string.isRequired
    }),
    to: PropTypes.shape({
      transform: PropTypes.string.isRequired
    })
  })
};

exports.default = BitIconSpinner;
